(function (factory) {
	var moduleName = "ccsDsProductDetails";

	if (typeof ccs_define === "function") {
		ccs_define(moduleName, ["jquery"], factory);
		return;
	}

	var moduleExport = factory(window.ccsJq);
	if (typeof moduleExport !== "undefined") {
		window[moduleName] = moduleExport;
	}
}
(function ($) {
	"use strict";
	/*global $: false*/
	/*jslint vars: true*/

	/* Switches to specified tab.
	----------------------------------------------------------*/
	function switchToTab(tabLink, main) {

		var areaId = tabLink.attr("id").replace("-tab-", "-area-");

		main.find("a.ccs-ds-details-tab-open")
			.removeClass("ccs-ds-details-tab-open")
			.addClass("ccs-ds-details-tab-close");

		tabLink.removeClass("ccs-ds-details-tab-close");
		tabLink.addClass("ccs-ds-details-tab-open");

		main.children("div").hide();
		$("#" + areaId).show();
	}

	/* Expands specified section.
	----------------------------------------------------------*/
	function expandSection(sectionLink) {

		var sectionArea = sectionLink.next();
		sectionLink.toggleClass("ccs-ds-details-section-open");
		sectionLink.toggleClass("ccs-ds-details-section-close");
		sectionArea.slideToggle("fast");
	}

	/* Setups expandable specifications.
	----------------------------------------------------------*/
	function setupExtendedSpecs(main) {

		var extendedSpecs = main.find(".ccs-ds-details-specs-extended");
		var specsMore = main.find(".ccs-ds-details-specs-more");
		var specsLess = main.find(".ccs-ds-details-specs-less");

		if (specsMore.length > 0) {
			specsMore.click(function () {
				specsMore.hide();
				extendedSpecs.show("fast");
				specsLess.show();
				return false;
			});
		}

		if (specsLess.length > 0) {
			specsLess.click(function () {
				specsLess.hide();
				extendedSpecs.hide("fast");
				specsMore.show();
				return false;
			});
		}
	}

	/* Initializes details area.
	----------------------------------------------------------*/
	function initialize(detailsId) {

		var details = $("#" + detailsId);
		var main = details.find(".ccs-ds-details-main");

		if (main.hasClass("ccs-ds-details-section")) {
			main.children("a").click(function () {
				var link = $(this);
				expandSection(link);
				return false;
			});
		}

		if (main.hasClass("ccs-ds-details-tab")) {
			main.find("ul > li > a").click(function () {
				var link = $(this);
				switchToTab(link, main);
				return false;
			});
		}

		setupExtendedSpecs(main);
	}

	(function () {
		/*global window: false*/

		window.ccs_ds_productDetails = {
			init: initialize
		};
	} ());

}));
